import React, { useState, useMemo, useEffect } from 'react';
import { AutoComplete, Button, Flex, Input, Space } from 'antd';
import CustomerService from "services/customer"
import CustomerInfo  from "components/customer/Info"
import _ from "lodash"

const service = new CustomerService();
const CustomerPicker = (props) => {
    const [customer, setCustomer] = useState({})
    const [data, setData] = useState([]);

    useEffect(() => {
        loadData();
    }, [])

    const loadData = async (data) => {
        var lst = await service.list(data);
        setData(lst);
        setOptions(lst.map(x => ({ label: `${x.phone} - ${x.full_name}`, value: x.phone })))
    }

    const delaySearch = useMemo(() => _.debounce(loadData, 500), []);

    const getCustomer = async (phone) => {

        //  var cus = await service.getByPhone(phone);

        var cus = data.find(x => x.phone == phone);
        if (props.onCustomerChange) {
            props.onCustomerChange(cus);
        }
    

        // if (cus) {
        //     form.setFieldsValue({ shipping_address: { full_name: cus.full_name, address: cus.address } })
        // }
        return cus;
    }
    const [value, setValue] = useState('');
    const [options, setOptions] = useState([]);

    const getCustomerDelay = useMemo(() => _.debounce(getCustomer, 500), []);
    const onChange = (e) => {
        getCustomer(e)
        if (props.onChange) {
            props.onChange(e)
        }
    }

    const onSelect = data => {
        props.onChange(data);

    };

    const searchCustomer = (text) => {
        return data.filter(x => x.search_text.includes(text)).map(x => ({ label: `${x.phone} - ${x.full_name}`, value: x.phone }));
    }

    return (
        <>
            <div>

                <Space direction='vertical' style={{ width: "100%" }}>


                    {/* <Input {...props} onChange={onChange} ></Input> */}
                    {/* {customer &&
                        <Flex justify='flex-end'>


                            <Button type='link'>Xem thông tin</Button>
                        </Flex>
                    } */}

                    <AutoComplete
                        {...props}
                        options={options}
                        onChange={onChange}
                        onSelect={onSelect}
                        onSearch={text => setOptions(searchCustomer(text))}
                        placeholder="Số điện thoại hoặc tên"
                    />
                   
                    <CustomerInfo phone ={props.value}></CustomerInfo>
                </Space>
            </div>
        </>
    );
};
export default CustomerPicker;